import { useActiveThemeContext } from '../providers/ActiveThemeProvider'
import { useCurrentShopContext } from './useCurrentShopContext'
import { useSitesQuery } from './useSitesQuery'
import { useThemeEditorContext } from './useThemeEditorContext'

export type Site = Extract<
  NonNullable<ReturnType<typeof useSitesQuery>['sitesQuery']['data']>['sites'][number],
  { title: string }
>

export type SitesGroup = Extract<
  NonNullable<ReturnType<typeof useSitesQuery>['sitesQuery']['data']>['sites'][number],
  { sites: any }
>

export const usePages = () => {
  const { currentPageId } = useThemeEditorContext()
  const { currentShop } = useCurrentShopContext()
  const { activeTheme } = useActiveThemeContext()
  const { sitesQuery } = useSitesQuery([
    { shop_id: currentShop.id },
    {
      shop_theme_id: activeTheme.id,
    },
  ])

  const pages =
    sitesQuery.data?.sites.flatMap((site) => ('sites' in site ? site.sites || [] : site)) || []

  const currentPage = pages.find((page) => page.id === currentPageId)

  return {
    sites: sitesQuery.data?.sites,
    currentPage,
    refetchPages: sitesQuery.refetch,
  }
}
